// Mock data for Azure Sovereign Yacht Charter website

export const features = [
  {
    id: 1,
    icon: "Anchor",
    title: "Luxury Fleet",
    description: "World-class yachts with state-of-the-art amenities"
  },
  {
    id: 2,
    icon: "Users",
    title: "Expert Crew",
    description: "Professional staff dedicated to your comfort"
  },
  {
    id: 3,
    icon: "MapPin",
    title: "Prime Locations",
    description: "Access to Asia's most stunning destinations"
  },
  {
    id: 4,
    icon: "Star",
    title: "Premium Service",
    description: "Tailored experiences exceeding expectations"
  }
];

export const yachts = [
  {
    id: "yacht-1",
    name: "Azure Majesty",
    type: "Motor Yacht",
    length: "98 ft",
    guests: 12,
    crew: 6,
    price: 25000,
    image: "https://images.pexels.com/photos/29318860/pexels-photo-29318860.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    description: "Experience unparalleled luxury aboard Azure Majesty, a stunning motor yacht designed for those who appreciate the finer things in life. This magnificent vessel combines elegant design with state-of-the-art amenities."
  },
  {
    id: "yacht-2",
    name: "Sovereign Pearl",
    type: "Sailing Yacht",
    length: "112 ft",
    guests: 10,
    crew: 5,
    price: 32000,
    image: "https://images.unsplash.com/photo-1528154291023-a6525fabe5b4?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzNTl8MHwxfHNlYXJjaHwxfHx5YWNodHxlbnwwfHx8fDE3NzAxMjQ1OTZ8MA&ixlib=rb-4.1.0&q=85",
    description: "Set sail on Sovereign Pearl, an exquisite sailing yacht that offers the perfect blend of traditional sailing experience and modern luxury. Navigate the pristine waters of Indonesia in unmatched style."
  },
  {
    id: "yacht-3",
    name: "Pacific Dream",
    type: "Catamaran",
    length: "82 ft",
    guests: 8,
    crew: 4,
    price: 18000,
    image: "https://images.pexels.com/photos/29318858/pexels-photo-29318858.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    description: "Pacific Dream is a luxurious catamaran offering exceptional stability and space. Perfect for exploring the scenic Japanese coastline with comfort and elegance."
  }
];

export const destinations = [
  {
    id: "thailand",
    name: "Thailand",
    tagline: "Tropical Paradise",
    image: "https://images.unsplash.com/photo-1639491146900-8c892c0f6875?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Njd8MHwxfHNlYXJjaHwxfHx0cm9waWNhbCUyMGJlYWNoJTIwVGhhaWxhbmR8ZW58MHx8fHwxNzcwMTI0NjAxfDA&ixlib=rb-4.1.0&q=85",
    description: "Discover the enchanting beauty of Thailand's coastline, from the stunning limestone karsts of Phang Nga Bay to the pristine beaches of the Andaman Sea. Experience vibrant marine life, ancient temples, and world-class hospitality."
  },
  {
    id: "indonesia",
    name: "Indonesia",
    tagline: "Island Adventure",
    image: "https://images.unsplash.com/photo-1750068418058-80db4f76e863?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA2OTV8MHwxfHNlYXJjaHwzfHxJbmRvbmVzaWElMjBjb2FzdCUyMHRyb3BpY2FsfGVufDB8fHx8MTc3MDEyNDYwNXww&ixlib=rb-4.1.0&q=85",
    description: "Explore Indonesia's 17,000 islands, home to some of the world's most diverse marine ecosystems. From Komodo dragons to pristine coral reefs, experience nature at its most spectacular while enjoying unparalleled luxury."
  },
  {
    id: "japan",
    name: "Japan",
    tagline: "Coastal Elegance",
    image: "https://images.unsplash.com/photo-1734107006242-6c3a881fec1d?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxOTJ8MHwxfHNlYXJjaHwxfHxKYXBhbiUyMGNvYXN0fGVufDB8fHx8MTc3MDEyNDY0OXww&ixlib=rb-4.1.0&q=85",
    description: "Experience the unique blend of ancient tradition and modern sophistication along Japan's coastline. From the tropical Okinawa islands to historic coastal towns, discover a different side of Japan from the luxury of your private yacht."
  }
];

export const testimonials = [
  {
    id: 1,
    name: "Sarah Mitchell",
    title: "CEO, Tech Ventures",
    image: "https://images.unsplash.com/photo-1494790108377-be9c29b29330?w=400",
    quote: "CC Yachting provided an absolutely unforgettable experience. The yacht was immaculate, the crew was exceptional, and exploring Thailand's islands was pure magic. This is luxury at its finest."
  },
  {
    id: 2,
    name: "James Chen",
    title: "Entrepreneur",
    image: "https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=400",
    quote: "From the moment we stepped aboard, we knew this would be special. The attention to detail, the gourmet dining, and the stunning Indonesian waters made this our best vacation ever."
  },
  {
    id: 3,
    name: "Emma Thompson",
    title: "Designer",
    image: "https://images.unsplash.com/photo-1438761681033-6461ffad8d80?w=400",
    quote: "The perfect blend of adventure and luxury. Exploring Japan's coastline on CC Yachting was a dream come true. Professional crew, beautiful yacht, incredible journey."
  },
  {
    id: 4,
    name: "Robert Hamilton",
    title: "Investment Banker",
    image: "https://images.unsplash.com/photo-1500648767791-00dcc994a43e?w=400",
    quote: "I've chartered yachts around the world, and CC Yachting sets a new standard. Impeccable service, world-class amenities, and breathtaking destinations. Highly recommended!"
  }
];

export const navLinks = [
  { label: "Home", href: "/" },
  { label: "Our Fleet", href: "/yachts" },
  { label: "Destinations", href: "/destinations" },
  { label: "About", href: "/about" }
];

export const contactInfo = {
  location: "Phuket Thailand",
  address: "Yaowarat Road Talat Yai Subdistrict",
  email: "info@competconcept.com",
  phone: "+66"
};
